import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class MonthlyProcessService {
  private apiUrl = '/monthlyprocesses';

  constructor(private http: HttpService) { }

  post(
    ownerId: number,
    bookyearmonthTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${ownerId}`;
    const jsonInput = {
      bookyearmonthTx: bookyearmonthTx,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    ownerId: number,
    bookyearmonthTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${ownerId}`;
    const jsonInput = {
      bookyearmonthTx: bookyearmonthTx,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/monthly-process/monthly-process.service.ts